export { default } from "./ReviewCountSkeleton.jsx";
